export default [
  {
    "id": 1,
    "cantsuku_id": 4,
    "level": 1,
    "text": "Vitalityステータスは何色？",
    "example": "ブルー/ブロンズ/誰もが羨むゴールド！",
    "hash1": "Vitalityステータス",
    "hash2": "",
    "link_text": "Vitalityステータスとは？",
    "link_href": "//vitality.sumitomolife.co.jp/about/insurance/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q1/`,
  },
  {
    "id": 2,
    "cantsuku_id": 13,
    "level": 1,
    "text": "階段派？エスカレーター派？",
    "example": "階段派/エスカレーター派",
    "hash1": "階段orエスカレーター",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q2/`,
  },
  {
    "id": 3,
    "cantsuku_id": 3,
    "level": 1,
    "text": "先週はアクティブチャレンジ達成できた？",
    "example": "達成できた/達成できなかった/今週こそは……",
    "hash1": "先週のアクティブチャレンジ",
    "hash2": "",
    "link_text": "アクティブチャレンジとは？",
    "link_href": "//vitality.sumitomolife.co.jp/reward/active/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q3/`,
  },
  {
    "id": 4,
    "cantsuku_id": 1,
    "level": 1,
    "text": "Vitalityで気に入ってるところは？",
    "example": "運動しなきゃ！と思えるところ/リワードが魅力的だった！",
    "hash1": "Vitalityのお気に入りポイント",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q4/`,
  },
  {
    "id": 5,
    "cantsuku_id": 36,
    "level": 1,
    "text": "運動するなら、朝派？昼派？夜派？",
    "example": "朝派/昼派/夜派",
    "hash1": "運動するなら",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q5/`,
  },
  {
    "id": 6,
    "cantsuku_id": 37,
    "level": 1,
    "text": "アクティブチャレンジへの決意表明をお願いします！",
    "example": "毎週達成！/ほどほどに頑張る！",
    "hash1": "アクティブチャレンジ決意表明",
    "hash2": "",
    "link_text": "アクティブチャレンジとは？",
    "link_href": "//vitality.sumitomolife.co.jp/reward/active/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q6/`,
  },
  {
    "id": 7,
    "cantsuku_id": 16,
    "level": 1,
    "text": "子供の頃好きだったスポーツや遊びは？",
    "example": "鬼ごっこ/キックベース/どろけい",
    "hash1": "子供の頃とスポーツ",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q7/`,
  },
  {
    "id": 8,
    "cantsuku_id": 10,
    "level": 1,
    "text": "Vitality年齢は実年齢と何歳差？",
    "example": "ぴったり！/実年齢+3歳...",
    "hash1": "Vitality年齢と実年齢の差",
    "hash2": "Vitalityオンラインチェック",
    "link_text": "Vitality年齢とは？",
    "link_href": "https://sumitomolife.dga.jp/faq_detail.html?id=540&category=35&page=1",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q8/`,
  },
  {
    "id": 9,
    "cantsuku_id": 45,
    "level": 1,
    "text": "ウェアラブルデバイスは何か使ってる？",
    "example": "Apple Watch/GARMIN",
    "hash1": "使っているウェアラブルデバイス",
    "hash2": "",
    "link_text": "アクティブチャレンジ Apple Watchとは？",
    "link_href": "//vitality.sumitomolife.co.jp/reward/apple_watch/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q9/`,
  },
  {
    "id": 10,
    "cantsuku_id": 27,
    "level": 2,
    "text": "運動するときに音楽は聴く？どんな音楽？",
    "example": "アップテンポな音楽！/お気に入りのバンド/外の音を楽しむ！",
    "hash1": "運動中に聴く音楽",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q10/`,
  },
  {
    "id": 11,
    "cantsuku_id": 21,
    "level": 2,
    "text": "今日やった、健康のためにいいことを教えて！",
    "example": "無糖の炭酸水を選択/階段を使った",
    "hash1": "今日健康のためにやったこと",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q11/`,
  },
  {
    "id": 12,
    "cantsuku_id": 53,
    "level": 2,
    "text": "いつもより多く歩くために心がけていることはある？",
    "example": "寄り道しながら帰る/一個先のスーパーまで歩く",
    "hash1": "いつもより多く歩くために心がけていること",
    "hash2": "Vitalityウォーキング部",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q12/`,
  },
  {
    "id": 13,
    "cantsuku_id": 9,
    "level": 2,
    "text": "健康のためによく食べるようにしているものは？",
    "example": "玄米/緑黄色野菜/キャベツはいつも大盛り！",
    "hash1": "健康のための食事",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q13/`,
  },
  {
    "id": 14,
    "cantsuku_id": 41,
    "level": 2,
    "text": "あなたのランやウォーキングの相棒を教えて！",
    "example": "シューズ/ウェア/キャップ",
    "hash1": "あなたのランの相棒",
    "hash2": "Vitalityラン部",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q14/`,
  },
  {
    "id": 15,
    "cantsuku_id": 46,
    "level": 2,
    "text": "ステータスアップへの決意表明をお願いします！",
    "example": "ブロンズ目指して頑張るぞ！",
    "hash1": "ステータスアップ決意表明",
    "hash2": "",
    "link_text": "Vitalityステータスとは？",
    "link_href": "//vitality.sumitomolife.co.jp/about/insurance/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q15/`,
  },
  {
    "id": 16,
    "cantsuku_id": 15,
    "level": 2,
    "text": "健康のために、やらないと決めていることはある？",
    "example": "21時以降にご飯を食べない！",
    "hash1": "健康のためにやらないこと",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q16/`,
  },
  {
    "id": 17,
    "cantsuku_id": 2,
    "level": 2,
    "text": "休日に歩数を稼ぐために何してる？",
    "example": "家族とお出かけ/犬の散歩で遠出する/息子のサッカー応援",
    "hash1": "休日の歩数確保方法",
    "hash2": "休日Vitality",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q17/`,
  },
  {
    "id": 18,
    "cantsuku_id": 8,
    "level": 2,
    "text": "昨日は何ポイント獲得できた？",
    "example": "初オンラインチェックで7000pt/12000歩、歩いて120pt/parkrunに参加して200pt",
    "hash1": "昨日獲得できたポイント",
    "hash2": "",
    "link_text": "アクティブチャレンジとは？",
    "link_href": "//vitality.sumitomolife.co.jp/reward/active/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q18/`,
  },
  {
    "id": 19,
    "cantsuku_id": 47,
    "level": 3,
    "text": "Kit Oisixは使ったことある？使ってみたい？",
    "example": "よく使う！/使ってみたい！",
    "hash1": "KitOisixで料理",
    "hash2": "Vitalityお料理部",
    "link_text": "オイシックス ヘルシーフード特典とは？",
    "link_href": "//vitality.sumitomolife.co.jp/guide/partner/oisix/",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q19/`,
  },
  {
    "id": 20,
    "cantsuku_id": 38,
    "level": 3,
    "text": "Vitalityに入ってから始めたことはある？",
    "example": "ウェアラブルデバイスを買った/ジムに通うようになった",
    "hash1": "Vitalityに入って始めたこと",
    "hash2": "初めてのVitality",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q20/`,
  },
  {
    "id": 21,
    "cantsuku_id": 51,
    "level": 3,
    "text": "今日という日に点数をつけると？",
    "example": "100点満点！",
    "hash1": "今日という日に点数をつけると",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q21/`,
  },
  {
    "id": 22,
    "cantsuku_id": 30,
    "level": 3,
    "text": "Vitality特典（リワード）で嬉しいのはどれ？",
    "example": "adidasのスポーツ用品割引/Kit Oisixの割引/Hotels.comの宿泊割引",
    "hash1": "Vitality特典で嬉しいもの",
    "hash2": "",
    "link_text": "Vitality特典（リワード）とは？",
    "link_href": "//vitality.sumitomolife.co.jp/reward",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q22/`,
  },
  {
    "id": 23,
    "cantsuku_id": 55,
    "level": 3,
    "text": "Vitalityに入ってから、体重は変化した？",
    "example": "痩せました！/現状維持だなー…",
    "hash1": "体重の変化",
    "hash2": "ダイエット",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q23/`,
  },
  {
    "id": 24,
    "cantsuku_id": 12,
    "level": 3,
    "text": "いまの健康状態を、漢字一文字で表すと？",
    "example": "快/重/強",
    "hash1": "いまの健康状態を一文字で",
    "hash2": "",
    "link_text": "",
    "link_href": "",
    "ogp_url": `${process.env.VUE_APP_PATH}himekuri_q24/`,
  },
]
